/* Scroll-state control for CHICHICAS floating header; no dependency on Horizon's sticky observer. */
(() => {
  if (window.__chichicasFloatingHeaderScrollBound) return;
  window.__chichicasFloatingHeaderScrollBound = true;
  let queued = false;
  const update = () => {
    document.documentElement.classList.toggle('chichicas-scrolled', window.scrollY > 24);
    queued = false;
  };
  const onScroll = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', update);
  update();
})();
